import React from 'react'

function SocialMedia(props) {
    return (
    <div className="socialMedia">
        <a href={props.website} target="_blank" rel="noopener noreferrer" >
            <img src={props.imgsrc} id="media" alt={props.name} />
        </a>
    </div>);
}

export default SocialMedia;